<app-header></app-header>

<div id="page-not-found">
    <div class="container-fluid">

        <div class="row justify-content-center align-items-center" style="min-height: 100vh;">
            <div class="col-12">
                <img src="assets/img/common/page-not-found.png" alt="page-not-found" class="w-100">
            </div>
        </div>

    </div>
</div> <!-- end of page-not-found -->